export default __webpack_public_path__ + "static/media/slider_image2.bb8fad53.jpg";